type OperationType = 'Bid' | 'Offer' | 'Swap' | undefined;

export type { OperationType };
